import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col col-auto me-4"
}
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { class: "h5" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }


export default /*@__PURE__*/_defineComponent({
  __name: 'AgencyOverviewContact',
  props: {
    title: {
        type: String,
        default: null,
    },
    name: {
        type: String,
        default: null,
    },
    email: {
        type: String,
        default: null,
    },
    phone: {
        type: String,
        default: null,
    },
    fax: {
        type: String,
        default: null,
    },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (__props.name || __props.email || __props.phone || __props.fax)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h4", _hoisted_3, _toDisplayString(__props.title), 1)
        ]),
        (__props.name)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "h5" }, " Name:", -1)),
              _createTextVNode(" " + _toDisplayString(__props.name), 1)
            ]))
          : _createCommentVNode("", true),
        (__props.phone)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "h5" }, "Phone:", -1)),
              _createTextVNode(" " + _toDisplayString(__props.phone), 1)
            ]))
          : _createCommentVNode("", true),
        (__props.email)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "h5" }, "Email:", -1)),
              _createTextVNode(" " + _toDisplayString(__props.email), 1)
            ]))
          : _createCommentVNode("", true),
        (__props.fax)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "h5" }, "Fax:", -1)),
              _createTextVNode(" " + _toDisplayString(__props.fax), 1)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})